import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import {
  currentPageAtom,
  pageTimeAtom,
  prevPageAtom,
} from '../store/index.atom';

/*페이지가 변경 될 때마다 현재 페이지에서 체류한 페이지의 타임을 업데이트 */

interface Props {
  resetStart: () => void;
  getStayTime: () => number;
}

const useSetPageStayTime = ({ resetStart, getStayTime }: Props) => {
  const setPageTime = useSetAtom(pageTimeAtom);

  const currentPage = useAtomValue(currentPageAtom);
  const prevPage = useAtomValue(prevPageAtom);

  /*페이지 전환 시 마다, 직전 페이지의 체류 시간을 업데이트 한다 
  타이머는 초기화 하여 새로운 페이지에서 타이머를 새롭게 시작할 수 있도록 한다 */
  useEffect(() => {
    setPageTime((prev) => {
      const stayTime = getStayTime();
      if (prev === null) {
        return {
          [prevPage]: stayTime,
        };
      }
      return {
        ...prev,
        [prevPage]: stayTime,
      };
    });
    resetStart();
  }, [currentPage, prevPage]);
};

export default useSetPageStayTime;
